// src/utils/analytics.js
//
// Runtime injector for Google Tag Manager. When REACT_APP_GTM_ID is set,
// we inject the standard GTM head snippet + <noscript> iframe on first
// mount. When it's not set (local dev, staging without tracking), we do
// nothing — no console errors, no failed requests.
//
// Why runtime injection instead of hardcoding in index.html:
//   - Marketing owns the GTM container ID and can rotate it without a
//     code deploy (just change the env var and restart the build).
//   - Same codebase works across environments (dev/staging/prod) with
//     no need for conditional HTML templating.
//   - Once GTM is loaded, marketing can add/remove any tracking tag
//     (GA4, Meta Pixel, LinkedIn Insight, Hotjar) through the GTM
//     dashboard without asking engineering.

const GTM_INSTALLED_FLAG = '__dublabs_gtm_installed__';

export function installGTM() {
  const gtmId = process.env.REACT_APP_GTM_ID;
  if (!gtmId) return; // no-op when not configured

  // Guard against double-installation (StrictMode + hot reload).
  if (window[GTM_INSTALLED_FLAG]) return;
  window[GTM_INSTALLED_FLAG] = true;

  // Standard GTM data-layer bootstrap + async script tag.
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    'gtm.start': new Date().getTime(),
    event: 'gtm.js',
  });

  const script = document.createElement('script');
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtm.js?id=${gtmId}`;
  document.head.appendChild(script);

  // <noscript> iframe fallback for users with JavaScript disabled.
  const noscript = document.createElement('noscript');
  const iframe = document.createElement('iframe');
  iframe.src = `https://www.googletagmanager.com/ns.html?id=${gtmId}`;
  iframe.height = '0';
  iframe.width = '0';
  iframe.style.display = 'none';
  iframe.style.visibility = 'hidden';
  noscript.appendChild(iframe);
  document.body.insertBefore(noscript, document.body.firstChild);
}
